
class SearchHandler {

    constructor(){
        this.currentComponent = null;
        this.showSearchStateFn = null;
    }

    setShowSearchStateFn = (fn) =>{
        this.showSearchStateFn = fn;
    }

    setCurrentComponent = (component) =>{
        this.currentComponent = component;
        const isSearchable = component.isSearchable ? component.isSearchable(): false;
        this.showSearchStateFn(isSearchable);
        console.log("SearchHandler.setCurrentComponent: isSearchable=", isSearchable);
    }

    search = (value)=>{
        this.currentComponent.search(value);
    }

}

const searchHandler = new SearchHandler();

export default searchHandler;